<template>
  <el-card class="h-full relative">
    <div class="w-full h-full" v-if="showHome">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="培训名称"
          maxlength="50"
          v-model="searchData.name"
          clearable
        />
        <el-date-picker
          v-model="searchData.date"
          type="daterange"
          class="mr-10px"
          size="small"
          range-separator="至"
          :start-placeholder="`${$t('开始日期')}`"
          :end-placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <!-- <el-date-picker
          v-model="searchData.dateStart"
          type="date"
          size="small"
          class="mr-10px !w-50"
          :placeholder="`${$t('开始日期')}`"
        />
        <el-date-picker
          v-model="searchData.dateEnd"
          type="date"
          size="small"
          class="mr-10px !w-50"
          :placeholder="`${$t('结束日期')}`"
        /> -->
        <el-select
          v-model="searchData.trainingType"
          size="small"
          :placeholder="`${$t('培训类型')}`"
          class="mr-10px !w-50"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in trainingType"
            :key="index"
            :label="item.displayName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.status"
          size="small"
          :placeholder="`${$t('培训状态')}`"
          class="mr-10px !w-50"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item"
            :value="index"
          ></el-option>
        </el-select>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="培训名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="培训类型"
          prop="trainingTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="包含课件数量"
          prop="coursewareCount"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="课件累计学时" prop="coursewareTimes" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.coursewareTimes | showText('second') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已完成学时" prop="finishTimes" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.finishTimes | showText('second') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="课件包含学分"
          prop="coursewareCredits"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="已获得学分"
          prop="finishCredits"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="学习开始时间" prop="trainingDateStart" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.trainingDateStart | showText('time') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学习截止时间" prop="trainingDateEnd" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.trainingDateEnd | showText('time') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="培训状态" prop="status" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ statusList[scope.row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发布人"
          prop="publisherName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="openTrain(scope.row, scope.row.status)"
              size="mini"
              :disabled="scope.row.status === 3"
              >{{ btnText[scope.row.status] }}
            </el-button>
            <el-button size="mini" @click="viewDetail(scope.row)">查看记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <access-train
      v-else
      @cancell="handleCancel"
      :currentTrainObj="currentTrainObj"
      :isNeedReplaceRoute="isNeedReplaceRoute"
    />
    <el-dialog
      :visible.sync="dialogVisible"
      title="课件查看"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="1300px"
      class="small-dialog"
    >
      <view-courseware
        v-if="dialogVisible"
        :showBanner="true"
        ref="courseWareDetail"
        :trainId="trainId"
        :showList="true"
        :data="currentTrainObj"
        :isNeedReplaceRoute="isNeedReplaceRoute"
      ></view-courseware>
    </el-dialog>
  </el-card>
</template>

<script>
import { TrainingTaskApi } from '@wiz-api/training-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import utils from '@/components/safety/enumField/utils'
import dayjs from 'dayjs'
import { stat } from 'fs'
import viewCourseware from '../../components/trainManage/videoDetail'
import AccessTrain from '../../components/trainManage/AccessTrain'
import { formatSeconds } from '../../components/EnumField'

const trainingTaskApi = new TrainingTaskApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  name: 'task-list',
  components: { viewCourseware, AccessTrain },
  data() {
    return {
      // 是否替换路由
      isNeedReplaceRoute: '0',
      typeList: [],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      searchData: {
        date: [],
        name: '',
        trainingType: null,
        status: null,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      showAddDialog: false,
      dialogVisible: false,
      showHome: true,
      trainingType: [],
      statusList: ['待培训', '进行中', '已培训', '超期未培训'],
      btnText: ['开始培训', '继续培训', '培训回放', '开始培训'],
      currentTrainObj: '',
      trainId: '',
    }
  },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = val && dayjs(val).format('YYYY-MM-DD')
      }
      if (type === 'second') {
        result = val && formatSeconds(val)
      }
      return result
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  methods: {
    // 返回
    async handleCancel() {
      this.showHome = true
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
    },
    //  查看详情
    viewDetail(data) {
      this.trainId = data.id
      this.currentTrainObj = data
      this.dialogVisible = true
    },
    // 开始继续培训
    openTrain(data, type) {
      if (type !== 0) {
        this.$router.push({
          path: Wiz?.globalSettings?.globalConfig?.routerBase
            ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/train-manage/training`
            : '/educational-training-management-sm/train-manage/training', // 兼容低代码
          query: {
            id: data.id,
            status: `${data.status}`,
            isNeedReplaceRoute: this.$route.query.id && this.$route.query.mode ? '1' : '0',
          },
        })
        return
      }
      this.currentTrainObj = data
      this.isNeedReplaceRoute = this.$route.query.id && this.$route.query.mode ? '1' : '0'
      this.showHome = false
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...searchData,
      }
      if (this.searchData.date?.length) {
        data.dateStart = this.searchData.date[0]
        data.dateEnd = this.searchData.date[1]
      }

      this.equipTableLoading = true
      const [err, res] = await trainingTaskApi.getList(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
    // 字典
    async getRegulationType() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['TrainingType'],
        includeDetails: true,
      })
      if (err) return
      this.trainingType = res[0]?.dataItems
    },
    // 待办处理
    async waitResolve(id, mode) {
      if (mode !== 'read') {
        let status = null
        const [err, res] = await trainingTaskApi.getTask({ id })
        if (!err) {
          status = res.personStatus
          if (status === 3) {
            this.$message({
              showClose: true,
              message: '任务已超期，无法进行培训',
              type: 'warning',
            })
            return
          }
          this.openTrain({ id, status }, status)
        }
      } else {
        const [err, res] = await trainingTaskApi.callContinue({
          id,
        })
        if (!err) {
          this.openTrain({ id, status: res.status }, res.status)
        }
      }
    },
  },
  mounted() {
    this.getRegulationType()
    if (this.$route.query.id && this.$route.query.mode) {
      this.waitResolve(this.$route.query.id, this.$route.query.mode)
    } else {
      this.getEquipList()
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
